.BottomNavigation {
  height: var(--bottom-mobile-navigation-height);
  background: var(--primary);
  box-shadow: 0px -4px 6px 0px rgba(0, 0, 0, 0.15);
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
}

.Map,
.List {
  margin-right: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.Profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.LabelActive {
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: #ffffff;
}

.Label {
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: #ffffff;
}

@media screen and (hover: hover) and (pointer: fine)  {
  .BottomNavigation {
    height: var(--bottom-desktop-navigation-height);
  }
}
